import Filter from "../../../../models/Filter";
import { frequencyDbs } from "../../constants/dbs";

function getFilters() {
  const rangeMax = new Filter({
    label: "Max Freq.",
    key: "freqMax",
    value: 1,
    min: 0.00001,
    max: 1,
    defaultVal: 0.00001,
    isVisible: true,
    type: "number",
  });

  const dbFilters = Object.values(frequencyDbs).map((x) => {
    return new Filter({
      label: x.name,
      key: x.key,
      color: x.hex,
      value: 0,
      category: x.category,
    });
  });
  return [...dbFilters, rangeMax];
}

export default getFilters;
